import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _inherits from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import _possibleConstructorReturn from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
import _defineProperty from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// Contact Model
import Vue from 'vue';
import VuexORM from '@vuex-orm/core';
import Construction from "./Construction";
import Company from "./Company";
import Typology from "./Typology";
import Image from "./Image";
import ConstructionFlyer from "./ConstructionFlyer";
import FlyerTypology from "./FlyerTypology";
import FlyerImage from "./FlyerImage";
import { i18n } from "../../boot/i18n";
var Flyer = /*#__PURE__*/function (_VuexORM$Model) {
  _inherits(Flyer, _VuexORM$Model);
  var _super = _createSuper(Flyer);
  function Flyer() {
    _classCallCheck(this, Flyer);
    return _super.apply(this, arguments);
  }
  _createClass(Flyer, null, [{
    key: "entity",
    get:
    // This is the name used as module name of the Vuex Store.
    function get() {
      return 'flyers';
    }
  }, {
    key: "fields",
    value:
    // List of all fields (schema) of the user model. `this.attr` is used
    // for the generic field type. The argument is the default value.
    function fields() {
      return {
        id: this.attr(null),
        company_id: this.number(0),
        company: this.belongsTo(Company, 'company_id'),
        type: this.string('flyer'),
        pages: this.number(1),
        editable: this.attr(false),
        extended_typologies: this.boolean(false),
        first_page_layout: this.string(''),
        other_pages_layout: this.string(''),
        created_at: this.string(''),
        seller_type: this.string(''),
        constructions: this.belongsToMany(Construction, ConstructionFlyer, 'flyer_id', 'construction_id'),
        typologies: this.belongsToMany(Typology, FlyerTypology, 'flyer_id', 'typology_id'),
        images: this.belongsToMany(Image, FlyerImage, 'flyer_id', 'image_id')
      };
    }
  }, {
    key: "$generatePDF",
    value: function $generatePDF(flyer) {
      return Vue.prototype.$axios.get("/api/companies/".concat(flyer.company_id, "/flyers/").concat(flyer.id, "/pdf"), {
        headers: {
          Accept: 'application/pdf'
        },
        responseType: 'arraybuffer'
      });
    }
  }]);
  return Flyer;
}(VuexORM.Model);
_defineProperty(Flyer, "TYPE_OPTIONS", [{
  label: i18n.t('app.flyers.types.flyer'),
  value: 'flyer'
}, {
  label: i18n.t('app.flyers.types.brochure'),
  value: 'brochure'
}]);
_defineProperty(Flyer, "PAGE_OPTIONS", [{
  label: i18n.t('app.flyers.page_options.front'),
  value: 1
}, {
  label: i18n.t('app.flyers.page_options.front_back'),
  value: 2
}]);
_defineProperty(Flyer, "INFO_OPTIONS", [{
  label: i18n.t('app.flyers.info_options.my_company'),
  value: 'my_company'
}, {
  label: i18n.t('app.flyers.info_options.sales_company'),
  value: 'sales_company'
}, {
  label: i18n.t('app.flyers.info_options.sales_agency'),
  value: 'sales_agency'
}, {
  label: i18n.t('app.flyers.info_options.owner'),
  value: 'owner'
}, {
  label: i18n.t('app.flyers.info_options.design'),
  value: 'design'
}]);
_defineProperty(Flyer, "FIRST_PAGE_LAYOUTS_FLYER", [{
  label: i18n.t('app.flyers.first_page_layout_flyers.1_image'),
  value: '1_image'
}, {
  label: i18n.t('app.flyers.first_page_layout_flyers.3_images'),
  value: '3_images'
}]);
_defineProperty(Flyer, "OTHER_PAGES_LAYOUTS_FLYER", [{
  label: i18n.t('app.flyers.other_pages_layout_flyers.2_typologies'),
  value: '2_typologies',
  typologies: 2
}, {
  label: i18n.t('app.flyers.other_pages_layout_flyers.4_typologies'),
  value: '4_typologies',
  typologies: 4
}, {
  label: i18n.t('app.flyers.other_pages_layout_flyers.6_typologies'),
  value: '6_typologies',
  typologies: 6
}]);
_defineProperty(Flyer, "PAGE_LAYOUTS_BROCHURE", [{
  label: i18n.t('app.flyers.first_page_layout_brochure.1_image'),
  value: '1_image',
  constructions: 1,
  images: 1
}, {
  label: i18n.t('app.flyers.first_page_layout_brochure.3_images'),
  value: '3_images',
  constructions: 1,
  images: 3
}, {
  label: i18n.t('app.flyers.first_page_layout_brochure.2_constructions'),
  value: '2_constructions',
  constructions: 2,
  images: 1
}, {
  label: i18n.t('app.flyers.first_page_layout_brochure.4_constructions'),
  value: '4_constructions',
  constructions: 4,
  images: 1
}]);
_defineProperty(Flyer, "apiConfig", {
  actions: {
    generatePDF: function generatePDF(flyer) {
      return this.get("/api/companies/".concat(flyer.company_id, "/flyers/").concat(flyer.id, "/pdf"));
    }
  }
});
export { Flyer as default };